import { ReactNode } from 'react';

import { create } from 'zustand';

interface IHeaderActionsStore {
  actions: ReactNode | null;
  setActions: (actions: ReactNode) => void;
  clearActions: () => void;
  hideFooter: boolean;
  setHideFooter: (hideFooter: boolean) => void;
  hideSearch: boolean;
  setHideSearch: (hideSearch: boolean) => void;
}

export const useHeaderActionsStore = create<IHeaderActionsStore>(set => ({
  actions: null,
  setActions: actions => set({ actions }),
  clearActions: () => set({ actions: null }),
  hideFooter: false,
  setHideFooter: hideFooter => set({ hideFooter }),
  hideSearch: false,
  setHideSearch: hideSearch => set({ hideSearch }),
}));
